import { DocumentModel } from './../../models/simple-types/document.model';
import { APICONSTANTS } from '../../constants/api-constants';
import { HttpClient, HttpHeaders, HttpRequest, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericCrudService } from '../basic/generic.crud.service';
import { Observable, of } from 'rxjs';
import { catchError, first, switchMap } from 'rxjs/operators';
import { HostnameService } from '../basic/hostname.service';

@Injectable()
export class DocumentService extends GenericCrudService<DocumentModel> {
  constructor(http: HttpClient, protected toastrService: ToastrService,
    protected hostnameService: HostnameService) {
    super(http, toastrService, APICONSTANTS.ROUTEDOCUMENT, hostnameService);
  }

  getDocBc(idDoc, idBc): Observable<Blob> {
    return this.http.get(APICONSTANTS.URLAPI.value + this.route + 'getDocBc?idBc=' + idBc + '&idDoc=' + idDoc,
      { responseType: 'text' })
      .pipe(switchMap(filegeturl => {
        if (filegeturl) {
          return this.http.get(filegeturl, { responseType: 'blob' });
        }
        return of(null);
      }), catchError(err => this.requestCatchError(err, 'L\'enregistrement')));
  }
  getDocBp(idDoc, idBp): Observable<Blob> {
    return this.http.get(APICONSTANTS.URLAPI.value + this.route + 'getDocBp?idBp=' + idBp + '&idDoc=' + idDoc,
      { responseType: 'text' })
      .pipe(switchMap(filegeturl => {
        if (filegeturl) {
          return this.http.get(filegeturl, { responseType: 'blob' });
        }
        return of(null);
      }), catchError(err => this.requestCatchError(err, 'L\'enregistrement')));
  }

  deleteDocBc(idDoc, idBc): Observable<DocumentModel> {
    return this.http.get(APICONSTANTS.URLAPI.value + this.route + 'deleteDocBc?idBc=' + idBc + '&idDoc=' + idDoc,
      { responseType: 'text' })
      .pipe(switchMap(filedeleteurl => {
        if (filedeleteurl) {
          return this.http.delete(filedeleteurl, { reportProgress: true });
        }
        return of(null);
      }), catchError(err => this.requestCatchError(err, 'L\'enregistrement')));
  }

  deleteDocBp(idDoc, idBp): Observable<DocumentModel> {
    return this.http.get(APICONSTANTS.URLAPI.value + this.route + 'sendDocBp?idBp=' + idBp + '&idDoc=' + idDoc,
      { responseType: 'text' })
      .pipe(switchMap(filedeleteurl => {
        if (filedeleteurl) {
          return this.http.delete(filedeleteurl, { reportProgress: true });
        }
        return of(null);
      }), catchError(err => this.requestCatchError(err, 'L\'enregistrement')));
  }

  sendDocBc(filename, idBc: number, file: File): Observable<HttpEvent<{}>> {
    return this.http.get(APICONSTANTS.URLAPI.value + this.route + 'sendDocBc?idBc=' + idBc + '&libelleDoc=' + filename,
      { responseType: 'text' })
      .pipe(first(), switchMap((fileuploadurl: string) => {
        const headers = new HttpHeaders({ 'Content-Type': file.type });
        if (fileuploadurl) {
          const req = new HttpRequest('PUT', fileuploadurl, file, { headers });
          return this.http.request(req);
        }
        return of(null);
      }), catchError(err => {
        return this.requestCatchError(err, 'L\'enregistrement');
      }));
  }
  sendDocBp(filename, idBp: number, file: File): Observable<HttpEvent<{}>> {
    return this.http.get(APICONSTANTS.URLAPI.value + this.route + 'sendDocBp?idBp=' + idBp + '&libelleDoc=' + filename,
      { responseType: 'text' })
      .pipe(first(), switchMap(fileuploadurl => {
        const headers = new HttpHeaders({ 'Content-Type': file.type });
        if (fileuploadurl) {
          const req = new HttpRequest('PUT', fileuploadurl, file, { headers });
          return this.http.request(req);
        }
        return of(null);
      }), catchError(err => this.requestCatchError(err, 'L\'enregistrement')));
  }

  getAllFromBc(idBc: number): Observable<DocumentModel[]> {
    return this.http.get<DocumentModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getAllFromBc?idBc=' + idBc)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement des documents')));
  }
  getAllFromBp(idBc: number): Observable<DocumentModel[]> {
    return this.http.get<DocumentModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getAllFromBp?idBp=' + idBc,
      { headers: { responseType: 'text' } })
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement des documents')));
  }
}
